import { Flex, Spin } from 'antd'

import { useStyle } from './styles'

export const Loading = () => {
  const { styles } = useStyle()

  return (
    <Flex align="center" justify="center" className={styles.fallback}>
      <Spin />
    </Flex>
  )
}
